import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetClientPropertiesQuery } from '@/features/clients/clientsApi';
import RecordRouteGuard from '.';

export const ClientRouteGuard = ({ children }) => {
	const { clientId } = useParams();
	const { currentData, isLoading, isFetching, isUninitialized, error } =
		useGetClientPropertiesQuery(clientId);

	return (
		<RecordRouteGuard
			id={clientId}
			record={currentData?.clientRow}
			isLoading={isLoading || isFetching || isUninitialized}
			error={error}
			label='client'
		>
			{children}
		</RecordRouteGuard>
	);
};
